import React, { useRef, useState } from 'react';
import './Related_category.css'
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import { Pagination, Autoplay } from 'swiper/modules';

import Heading_title from '../../common-components/common-title/heading-title/Heading_title'
import Product_card from '../../common-components/common-card/product-card/Product_card'
import All_products from '../../common-components/all-products/All_products'

const Related_category = () => {
    return (
        <>
            <section className='Related_category_sec'>
                <div className='container'>
                    <Heading_title title={'Related Category'} subtitle={'Cash Counters Designed to Complement Your Business Flow'} />


                    <div className='slidersec'>

                        <Swiper
                            slidesPerView={1}
                            spaceBetween={10}
                            pagination={{
                                clickable: true,
                            }}
                            loop={true}
                            autoplay={{
                                delay: 2500,
                                disableOnInteraction: false,
                            }}

                            breakpoints={{
                                0: {
                                    slidesPerView: 2,
                                    spaceBetween: 2,
                                },
                                575: {
                                    slidesPerView: 3,
                                    spaceBetween: 5,
                                },
                                991: {
                                    slidesPerView: 4,
                                    spaceBetween: 10,
                                },
                            }}
                            modules={[Pagination , Autoplay]}
                            className="mySwiper"
                        >    {All_products.map((product, index) => (
                            <SwiperSlide>
                                <Product_card
                                    key={product?.id}
                                    image={product?.image}
                                    modelno={product?.title}
                                    product_name={product?.subtitle}
                                    link={`/products/${product?.id}`}
                                />
                            </SwiperSlide>
                        ))}
                        </Swiper>
                    </div>


                </div>
            </section>
        </>
    )
}

export default Related_category